












































/**
 * External dependencies.
 */
import { Component, Prop, Vue } from 'vue-property-decorator'
import vueDropzone from 'vue2-dropzone'

/**
 * Internal dependencies.
 */
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

@Component({
  components: {
    vueDropzone
  }
})
export default class UploadDdropzone extends Vue {
  @Prop() disabled!: boolean

  useCustomSlot: boolean = true
  resolutionRejected: boolean = false
  sizeRejected: boolean = false
  unacceptedFileType: boolean = false
  maxFilesExceeded: boolean = false

  dropzoneOptions: object = {
    url: 'https://httpbin.org/post',
    autoProcessQueue: false,
    // paramName: 'file', // The name that will be used to transfer the file
    thumbnailWidth: 600,
    // thumbnailHeight: 400,
    thumbnailMethod: 'contain',
    // createImageThumbnails: false,
    maxThumbnailFilesize: 21,
    maxFilesize: 21,
    maxFiles: 1,
    addRemoveLinks: false,
    previewTemplate: this.previewTemplate(),
    acceptedFiles: 'image/jpeg,image/pjpeg'
    // headers: { 'Upload-Header': 'header value' }
  }

  // annotate refs type
  $refs!: {
    uploadDropZone: any
  }

  mounted () {
    if (this.disabled) {
      this.$refs.uploadDropZone.disable()
    }
  }

  previewTemplate () {
    let template = `<div class="dz-preview dz-file-preview">
        <div class="dz-image">
          <div data-dz-thumbnail-bg></div>
        </div>
        <div class="dz-details">
          <div class="dz-filename"><span data-dz-name></span></div>
          <div class="dz-size" data-dz-size></div>
        </div>
        <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
        <div class="dz-success-mark"><span>✔</span></div>
        <div class="dz-error-mark"><span>✘</span></div>
        <div class="dz-error-message"><span data-dz-errormessage></span></div>
        <div><strong class="text-info">Please wait. This might take a moment...</strong></div>
      </div>`
    return template
  }

  vddrop (event: any) {
    // console.log('DROPPED', event)
  }

  vdfileAdded (file: any) {
    //
  }

  vdfilesAdded (files: any) {
    // reset for new file
    this.unacceptedFileType = false

    if (files.length > 1) {
      this.maxFilesExceeded = true
      return
    }

    this.maxFilesExceeded = false
    this.useCustomSlot = false
  }

  vdthumbGenerated (file: any, dataUrl: string) {
    const landscape = (file.width > file.height) ? true : false

    if (landscape && file.width < 2000 || !landscape && file.height < 2000) {
      this.resolutionRejected = true
    } else {
      this.resolutionRejected = false
    }

    if ((file.upload.total / 1024) >= 20000) {
      this.sizeRejected = true
    } else {
      this.sizeRejected = false
    }

    if (this.resolutionRejected || this.sizeRejected || this.unacceptedFileType) {
      this.useCustomSlot = true
      this.$refs.uploadDropZone.removeFile(file)
      return
    }

    if (this.maxFilesExceeded) {
      this.useCustomSlot = true
      this.$refs.uploadDropZone.removeAllFiles(true)
      return
    }

    this.$emit('set-uploaded-photo', file, dataUrl)
    setTimeout(() => {
      this.$refs.uploadDropZone.removeAllFiles(true)
      this.useCustomSlot = true
    }, 500)
  }

  vdsuccess () {
    //
  }

  vderror (file: any, message: string, xhr: any) {
    console.error('Dropzone Error.', message)

    if (file.type !== 'image/jpeg') {
      this.unacceptedFileType = true
    }

    // hacky, but for now, it works
    if (message === 'You can not upload any more files.') {
      this.maxFilesExceeded = true
    }
  }

  vdcanceled (file: any) {
    // console.log('Dropzone Canceled.', file)
  }

  vdsending (file: any, xhr: any, formData: any) {
    // example (append category later)
    formData.append('filesize', file.size)
  }

  // See all event here https://rowanwins.github.io/vue-dropzone/docs/dist/#/events
  vdqueueComplete () {
    // this.resetDropzone()
  }

  disableDropzone () {
    this.$refs.uploadDropZone.disable()
  }

  processPhotoUpload () {
    this.$refs.uploadDropZone.processQueue()
  }
}
